import { inject, Injectable, signal } from '@angular/core';

import type { ITokenLoginRequest, IUserResponse } from '../api/interfaces/auth.interface';
import { ApiService } from '../api/api.service';
import { ForbiddenError, UnauthorizedError } from '../api/errors';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Injectable({ providedIn: 'root' })
export class SessionRepository {
  readonly #api = inject(ApiService);
  readonly #user = signal<IUserResponse | null>(null);
  readonly user = this.#user.asReadonly();
  readonly #router = inject(Router);
  readonly #toastr = inject(ToastrService);

  async login(params: ITokenLoginRequest): Promise<void> {
    const res = await this.#api.tokenLogin(params);
    this.#user.set(res);
  }

  async logout(): Promise<void> {
    await this.#api.logout();
    this.#user.set(null);
  }

  async getCurrentUser(): Promise<void> {
    const res = await this.#api.getCurrentUser();
    this.#user.set(res);
  }

  setUser(res: IUserResponse) {
    this.#user.set(res);
  }

  async checkCurrentUser() {
    try {
      await this.getCurrentUser();
    } catch (e) {
      if (e instanceof ForbiddenError || e instanceof UnauthorizedError) {
        return;
      }
      throw e;
    }
    const user = this.user();
    if (!user) {
      return;
    }
    const message = `${user.email} のご登録ユーザーでログイン中です`;
    this.#router.navigate(['/']).then(() => {
      this.#toastr.info(message);
    });
  }
}
